/* global google */
const mapStreetViews = document.querySelectorAll('.mod-map__streetview');

mapStreetViews.forEach((el) => {
  // eslint-disable-next-line no-shadow
  function initialize(el, mapLat, mapLng) {
    const mapOptions = {
      center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
    };
    const map = new google.maps.Map(el, mapOptions);

    const panoramaOptions = {
      position: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
      pov: {
        heading: 34,
        pitch: 10,
      },
    };
    const panorama = new google.maps.StreetViewPanorama(el, panoramaOptions);
    map.setStreetView(panorama);
  }

  const mapLat = el.getAttribute('data-lat');
  const mapLng = el.getAttribute('data-lng');

  // eslint-disable-next-line no-unused-vars
  initialize(el, mapLat, mapLng);
});
